import React, { useEffect, useRef, useState } from 'react';
import { PageTypes, ResponseStatus, Theme } from 'ui/Helpers/utils';
import {
  getTipoServicoPagined,
  printTipoServico,
  deleteAllTipoServico,
  excelTipoServico,
} from 'core/services/GProj/tipoServico';
import { CSDSelPage, GridView, Textbox } from 'ui/components';

const columns = [
  { key: 'nrSeqTipoServico', type: GridView.ColumnTypes.Checkbox },
  { key: 'noTipoServico', title: 'Nome' },
  { key: 'cdTipoServico', title: 'Código' },
  /*
  { key: 'flgAtivo', title: 'Ativo' },
  { key: 'flgGeraNfs', title: 'FLGGERANFS' },
  */
  { key: 'serieNFS', title: 'Série Nota Fiscal' },
  /*
  { key: 'nrSeqTituloEspecie', title: 'Titulo Especie' },
  { key: 'nrSeqCfoEst', title: 'NrSeqCfoEst' },
  { key: 'nrSeqCfoPais', title: 'NrSeqCfoPais' },
  { key: 'nrSeqCfoExt', title: 'NrSeqCfoExt' },
  { key: 'nrSeqProdutoServico', title: 'Produto Servico'},
  { key: 'flgBuscaQtdeRemoto', title: 'FLGBUSCAQTDEREMOTO' },
  */
  { key: 'aliqIssqn', title: 'ISSQN', format: GridView.DataTypes.Decimal },
  { key: 'aliqPis', title: 'PI', format: GridView.DataTypes.Decimal },
  { key: 'aliqCofins', title: 'Cofins', format: GridView.DataTypes.Decimal },
  { key: 'aliqCsll', title: 'CSLL', format: GridView.DataTypes.Decimal },
  { key: 'aliqIR', title: 'IR', format: GridView.DataTypes.Decimal },
  { key: 'aliqInss', title: 'INSS', format: GridView.DataTypes.Decimal },
  /*
  { key: 'flgIssqnRetido', title: 'FLGISSQNRETIDO' },
  { key: 'flgPisRetido', title: 'FLGPISRETIDO' },
  { key: 'flgCofinsRetido', title: 'FLGCOFINSRETIDO' },
  { key: 'flgCsllRetido', title: 'FLGCSLLRETIDO' },
  { key: 'flgIssqnCidadeOrigem', title: 'FLGISSQNCIDADEORIGEM'},
  */
];

export default function TipoServico({
  transaction,
  onOpenPage,
  isActive,
  onOpenReport,
}) {
  const gridView = useRef();

  const [filtros, setFiltros] = useState({});
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  const search = async (params = null) => {
    setLoading(true);

    const { data, pagination } = await getTipoServicoPagined(params ?? filtros);

    if (gridView && gridView.current)
      gridView.current.setDataSource(data, pagination);

    setLoading(false);
  };
  useEffect(() => {
    async function load() {
      setLoading(true);

      const { data, pagination } = await getTipoServicoPagined({});

      if (gridView && gridView.current)
        gridView.current.setDataSource(data, pagination);

      setLoading(false);
    }
    load();
  }, []);

  const onColumnSort = async (sortBy) => {
    const filters = { ...filtros, sortBy };
    setFiltros(filters);
    await search(filters);
  };
  const onPageSizeChange = async (totalByPage) => {
    const filters = { ...filtros, totalByPage };
    setFiltros(filters);
    await search(filters);
  };
  const onPageChange = async (page) => {
    const filters = { ...filtros, page };
    setFiltros(filters);
    await search(filters);
  };
  const onOpenMaintenance = (registryKey = null) => {
    onOpenPage(
      transaction.noTransacao,
      'TipoServico/manutencao',
      PageTypes.Maintenence,
      registryKey
    );
  };
  const onRowDoubleClick = (sourceRow) => {
    const nrSeqTipoServico = sourceRow.find(
      (e) => e.key === 'nrSeqTipoServico'
    );
    onOpenMaintenance(nrSeqTipoServico.value);
  };

  const onPrint = async () => {
    setLoading(true);
    const { value } = await printTipoServico(filtros);

    onOpenReport(transaction.noTransacao, value);
    setLoading(false);
  };
  const onDownloadExcel = async () => {
    setLoading(true);

    const { value: base64 } = await excelTipoServico(filtros);

    if (base64) {
      const linkSource = `data:application/vnd.ms-excel;base64, ${base64}`;
      const downloadLink = document.createElement('a');
      downloadLink.href = linkSource;
      downloadLink.download = 'TipoServico.csv';
      downloadLink.click();
    }

    setLoading(false);
  };

  const onDelete = async () => {
    setLoading(true);
    const selecteds = gridView.current.getCheckBoxValuesAt(0);

    if (selecteds.length > 0) {
      const { status, message: msg } = await deleteAllTipoServico(
        selecteds.map((row) => row[0].value)
      );

      setLoading(false);
      setMessage({
        message: msg,
        theme: status === ResponseStatus.Success ? Theme.Success : Theme.Danger,
      });

      await search();
    } else {
      setLoading(false);
      setMessage({
        message: 'Não há registros selecionados para a exclusão.',
        theme: Theme.Danger,
      });
    }
  };

  return (
    <CSDSelPage
      isActive={isActive}
      title='Seleção de Tipo Serviço'
      loading={loading}
      transaction={transaction}
      onSearch={() => search()}
      onNew={onOpenMaintenance}
      onDelete={onDelete}
      onPrint={onPrint}
      onDownloadExcel={onDownloadExcel}
      message={message}
      onMessagerClose={() => setMessage(null)}
    >
      <div className='row mb-3'>
        <div className='col-6'>
          <Textbox
            maxLength={60}
            label='Nome do Tipo Demanda'
            text={filtros.noTipoDemanda}
            onChangedValue={(noTipoDemanda) =>
              setFiltros({ ...filtros, noTipoDemanda })
            }
          />
        </div>
        <div className='col'>
          <Textbox
            maxLength={80}
            label='Nome'
            text={filtros.noTipoServico}
            onChangedValue={(noTipoServico) =>
              setFiltros({ ...filtros, noTipoServico })
            }
          />
        </div>
      </div>
      <div className='row'>
        <div className='col'>
          <GridView
            ref={gridView}
            transaction={transaction}
            className='table-striped table-hover table-bordered table-sm'
            dataColumns={columns}
            onColumnSort={onColumnSort}
            onPageSizeChange={onPageSizeChange}
            onPageChange={onPageChange}
            onRowDoubleClick={onRowDoubleClick}
          />
        </div>
      </div>
    </CSDSelPage>
  );
}
